import { useEffect, useState } from "react";
import { listenToDesignsByGarment } from "../services/garmentDesignService";

export function useGarmentDesigns(garmentId) {
  const [designs, setDesigns] = useState([]);
  const [designsLoading, setDesignsLoading] = useState(true);
  const [designsError, setDesignsError] = useState(null);

  useEffect(() => {
    setDesignsLoading(true);
    setDesignsError(null);

    const unsubscribe = listenToDesignsByGarment(
      garmentId,
      (data) => {
        setDesigns(data);
        setDesignsLoading(false);
      },
      (error) => {
        console.error("Unable to load garment designs:", error);
        setDesignsError(error);
        setDesignsLoading(false);
      }
    );

    return () => unsubscribe();
  }, [garmentId]);

  return {
    designs,
    designsLoading,
    designsError,
  };
}
